<template>
  <div class="user-page full-height">
    <table-con>
      <div slot="search">
        <el-collapse v-show="queryInfo.isActive">
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">商品渠道:</div>
              <el-select
                v-model="query.platformType"
                placeholder="请选择商品渠道"
                size="small"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <!-- <el-input
                v-model="query.name"
                size="small"
                placeholder="请输入商品渠道"
              ></el-input> -->
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">商品名称:</div>
              <el-input
                v-model="query.goodsName"
                size="small"
                placeholder="请输入商品名称"
              ></el-input>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">录入用户:</div>
              <el-input
                v-model="query.createUserName"
                size="small"
                placeholder="请输入录入用户"
              ></el-input>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">录入日期:</div>
              <el-date-picker
                style="width: 100%"
                v-model="dateRangeValue"
                type="daterange"
                size="small"
                format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-col>
          </el-row>
          <!-- <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">标签:</div>
              <el-input
                v-model="query.name"
                size="small"
                placeholder="请输入标签"
              ></el-input>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">商品分类:</div>
              <el-input
                v-model="query.name"
                size="small"
                placeholder="请输入商品分类"
              ></el-input>
            </el-col>
          </el-row> -->
        </el-collapse>
        <el-row class="search-row">
          <el-col :span="16" class="display-row">
            <div class="search-btn-container search-btn-container-status">
              &nbsp;
            </div>
          </el-col>
          <el-col :span="8" class="display-row">
            <div class="search-btn-container">
              <el-button class="search-btn btn-gray" @click="onClear"
                >重置</el-button
              >
              <el-button
                class="search-btn btn-blue"
                @click="queryInfo.searchList()"
                >搜索</el-button
              >
              <el-button v-if="loadingUrl" class="search-btn btn-green" @click="handleUpData"
              >下载</el-button
              >
              <el-button v-else :loading="loading" class="search-btn btn-blue" @click="handleLoad"
              >导出</el-button
              >
              <!-- <el-button class="search-btn btn-blue">增加商品</el-button>
              <el-button class="search-btn btn-blue">批量导入</el-button> -->
              <el-button
                class="search-btn btn-blue"
                v-if="!queryInfo.isActive"
                type="primary"
                icon="el-icon-arrow-down"
                alt=""
                @click="queryInfo.onActive()"
                >展开</el-button
              >
              <el-button
                class="search-btn btn-green"
                v-if="queryInfo.isActive"
                icon="el-icon-arrow-up"
                alt=""
                @click="queryInfo.onActive()"
                >收起</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
          :header-cell-style="tableStyle.headerStyle"
          :cell-style="tableStyle.cellStyle"
          :data="pageList.tableData"
          border
          height="550"
        >
          <el-table-column type="index" label="序号" align="center" />
          <el-table-column prop="" label="操作" align="center" width="150px">
            <template #default="{ row }">
              <el-button class="list-btn btn-blue" @click="onEdit(row)"
                >编辑</el-button
              >
              <!-- <el-button class="search-btn btn-red" @click="onRemove(row)"
                >删除</el-button
              > -->
            </template>
          </el-table-column>
          <el-table-column prop="platformType" label="商品渠道" align="center">
            <template #default="{ row }">
              <span>{{
                returnStatus(row.platformType, platformType_status)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="商品图片" align="center">
            <template #default="{ row }">
              <img
                :src="row.pictureUrl"
                style="cursor: pointer"
                width="50px"
                height="50px"
                @click="chackImg(row)"
              />
            </template>
          </el-table-column>
          <el-table-column prop="address" label="商品信息" width="200px">
            <template #default="{ row }">
              <div>商品名称：{{ row.goodsName }}</div>
              <div>商品编码：{{ row.goodsCode }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="商品参数" width="200px">
            <template #default="{ row }">
              <div>规格：{{ row.goodsSize }}</div>
              <div>平均价格：{{ row.priceAvg }}</div>
              <!-- {{ row.goodsUrl }} -->
              <div style="cursor: pointer">
                商品链接：<a :href="row.goodsUrl">商品链接</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="录入日期"
            width="90"
            align="center"
          >
            <template #default="{ row }">
              {{ row.createTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createUserName"
            label="录入用户"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="orderCount" label="采购次数" align="center">
          </el-table-column>
          <el-table-column
            prop="checkCoefficientAvg"
            label="平均系数"
            align="center"
          >
          <template #default="{ row }">
              {{ +(row.checkCoefficientAvg || 0).toFixed(2) }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="address" label="标签" align="center">
            <template #default="{ row }">
              <el-tag>标签</el-tag>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="address" label="分类" align="center">
          </el-table-column> -->
          <el-table-column prop="remark" label="备注">
            <template #default="{ row }">
              <el-input
                type="textarea"
                placeholder="请输入备注"
                @blur="getEvalue(row)"
                v-model="row.remark"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
        <!-- 图片预览 -->
        <el-dialog
          :visible.sync="dialogVisible"
          v-if="dialogVisible"
          width="30%"
        >
          <img :src="dialogPic" width="100%" height="100%" />
        </el-dialog>

        <el-pagination
          v-bind="pagination"
          @size-change="pagination.sizeChange"
          @current-change="pagination.currentChange"
        ></el-pagination>
      </div>
    </table-con>
  </div>
</template>

<script>
import { returnStatus, platformType_status } from "@/class/status";
import { PageList } from "@/class";
import fa from "element-ui/src/locale/lang/fa";
export default {
  name: "goods",
  // name: "goods/goodsList",
  data() {
    const pageList = new PageList();
    const { queryInfo, pagination, page } = pageList;
    queryInfo.isActive = true;
    return {
      returnStatus: returnStatus,
      platformType_status: platformType_status,
      //列表、查询及分页
      pageList: pageList,
      queryInfo: queryInfo,
      query: queryInfo.query,
      page: page,
      pagination: pagination,
      visiable: false,
      title: undefined,
      queryData: {},
      dateRangeValue: [],
      dialogVisible: false,
      dialogPic: undefined,
      options: [
        {
          value: "0",
          label: "淘宝",
        },
        {
          value: "1",
          label: "1688",
        },
        {
          value: "2",
          label: "京东",
        },
        {
          value: "3",
          label: "拼多多",
        },
        {
          value: "4",
          label: "天猫",
        },
      ],
      loading: false,
      timer: null,
      loadingType: '0',
      loadingUrl: '',
    };
  },
  watch: {
    //监听时间选择器绑定值变化
    dateRangeValue() {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.dateRangeValue) {
        this.dateRangeValue = [];
        this.query.createTimeStart = "";
        this.query.createTimeEnd = "";
      } else {
        if (this.dateRangeValue.length > 0) {
          this.query.createTimeStart = this.dateRangeValue[0] / 1000;
          this.query.createTimeEnd = this.dateRangeValue[1] / 1000 + 86400;
        }
      }
    },
    //
    loading(newVal) {
      if (newVal) {
        // 启动轮询
        this.startPolling();
      } else {
        // 停止轮询
        this.stopPolling();
      }
    }
  },
  created() {
    this.getList();
    this.initPolling();
    this.queryInfo.searchList();
  },
  methods: {
    // 查看图片
    chackImg(row) {
      this.dialogVisible = true;
      this.dialogPic = row.pictureUrl;
    },
    // 编辑adn备注
    getEvalue(row) {
      let data = {
        id: row?.id,
        remark: row?.remark,
      };
      this.$http.post("/purchase/updateGoods", data).then((res) => {
        const { data: resData } = res;
        if (resData.code == 200) {
          this.$message({
            type: "success",
            message: resData.data,
          });
          this.queryInfo.searchList();
        }
      });
    },
    // 编辑
    onEdit(row) {
      this.$router.push({ path: "/goodsDetails", query: { id: row.id } });
    },
    // // 删除
    // onRemove() {},
    // 列表
    getList() {
      //重写请求列表接口
      this.queryInfo.searchList = () => {
        let params = {
          ...this.page,
          ...this.query,
        };
        this.$http
          .get("/purchase/goodsList", {
            params: params,
          })
          .then((res) => {
            const { data: resData } = res;
            console.log(resData, "resData");
            this.pageList.update(resData);
            // this.pageList.tableData = resData.data;
          });
      };
    },
    // 重置
    onClear() {
      this.query = {};
      this.dateRangeValue = [];
      this.queryInfo.searchList();
    },
    // 下载
    async handleUpData(){
      window.open(this.loadingUrl, "_blank");
      // const fileName = '商品列表.xlsx'; // 指定文件名
      // const link = document.createElement('a');
      // link.href = this.loadingUrl;
      // link.download = fileName;
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);

      const params = {
        type: 1,
      }
      const res = await this.$http.get("/purchase/checkExportStatus", {params})
      if(res.data.code === 200){
        this.loadingUrl = ''
        this.loading = false
      }
    },
    // 导出
    async handleLoad(){
      this.loading = true;
      const params = {
        ...this.query,
      }
      try{
        const res = await this.$http.get("/purchase/exportAction", {
          params,
          headers: {
            noLoading: true,
          },
        })
        console.log(res,'res===========222')
      }catch(err){
        // this.loading = false;
      }finally {
        // this.loading = false;
      }
    },
    startPolling() {
      this.stopPolling(); // 先清除已有定时器，避免重复
      this.timer = setInterval(async () => {
        console.log('每3秒执行一次逻辑');
        // 调用你需要的函数，比如 this.fetchData()
        const params = {
          type: this.loadingType,
        }
        const res = await this.$http.get("/purchase/checkExportStatus", {
          params,
          headers: {
            noLoading: true,
          },
        })
        // 0导出 1加载 2下载
        if(res.data.data.status === '0'){
          this.loading = false
          this.loadingUrl = ''
        }
        if(res.data.data.status === '1'){
          this.loading = true
          this.loadingUrl = ''
        }
        if(res.data.data.status === '2'){
          this.loading = false
          this.loadingUrl = res.data.data.url
        }
      }, 3000);
    },
    stopPolling() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    async initPolling() {
      const params = {
        type: 0,
      }
      const res = await this.$http.get("/purchase/checkExportStatus", {params})
      if(res.data.data.status === '0'){
        this.loading = false
        this.loadingUrl = ''
      }
      if(res.data.data.status === '1'){
        this.loading = true
        this.loadingUrl = ''
      }
      if(res.data.data.status === '2'){
        this.loading = false
        this.loadingUrl = res.data.data.url
      }
    },
  },
  beforeDestroy() {
    this.stopPolling(); // 组件销毁时清理定时器
  }
};
</script>

<style lang="scss" scoped></style>
